var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompButton',{attrs:{"placeholder":"选择商品","format":"{0}件商品","value":_vm.goodsCount},on:{"click":_vm.handleClickAdd,"remove":_vm.onRemoveItem,"view":_vm.onViewItem}})}
var staticRenderFns = []

export { render, staticRenderFns }